import Axios from "../utils/Axios";

export const getPendingBarcodes = async () => {
  const response = await Axios.get("/inventory-reports/pending-barcodes");
  return response.data;
};

export const getPendingBarcodesHistory = async (barcode: string) => {
  const response = await Axios.get(
    `/inventory-reports/pending-barcodes/history?barcode_value=${barcode}`
  );
  return response.data;
};
